"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuggestionAcceptance = void 0;
const react_1 = require("react");
const editableOpeningReducer_1 = require("../editable/editableOpeningReducer");
const useOpening_1 = __importDefault(require("../useOpening"));
function useSuggestionAcceptance(suggestion) {
    const { openingInput } = (0, useOpening_1.default)(suggestion.openingId);
    return (0, react_1.useMemo)(() => getSuggestionAcceptance(suggestion, openingInput), [
        suggestion,
        openingInput,
    ]);
}
exports.default = useSuggestionAcceptance;
var ImageSameness;
(function (ImageSameness) {
    ImageSameness[ImageSameness["NONE"] = 0] = "NONE";
    ImageSameness[ImageSameness["MODIFIED"] = 1] = "MODIFIED";
    ImageSameness[ImageSameness["FULL"] = 2] = "FULL";
})(ImageSameness || (ImageSameness = {}));
function getSuggestionAcceptance(suggestion, openingInput) {
    var _a;
    if (!openingInput) {
        return {
            inclusionStatus: "none-in-map",
            strategiesAvailable: {
                add: true,
                merge: false,
                overwrite: false,
            },
            totalImagesIfMerged: suggestion.input.images.length,
        };
    }
    const totalImagesIfMerged = (_a = openingInput === null || openingInput === void 0 ? void 0 : openingInput.images.length) !== null && _a !== void 0 ? _a : 0 + suggestion.input.images.length;
    const [minSameness, maxSameness] = getSuggestionSamenessRange(suggestion, openingInput);
    const inclusionStatus = getInclusionStatus(minSameness, maxSameness);
    const strategiesAvailable = getAvailableStrategies(suggestion, openingInput, inclusionStatus);
    return {
        inclusionStatus,
        strategiesAvailable,
        totalImagesIfMerged,
    };
}
exports.getSuggestionAcceptance = getSuggestionAcceptance;
function getSuggestionSamenessRange(suggestion, openingInput) {
    if (suggestion.input.images.length === 0) {
        return [ImageSameness.NONE, ImageSameness.NONE];
    }
    const samenesses = suggestion.input.images.map(suggestionImage => getMaxSameness(suggestionImage, openingInput.images));
    return getSamenessRange(samenesses);
}
function getInclusionStatus(minSameness, maxSameness) {
    if (maxSameness === ImageSameness.NONE) {
        return "none-in-map";
    }
    else if (minSameness === ImageSameness.FULL) {
        return "all-in-map-exact";
    }
    else if (minSameness === ImageSameness.NONE) {
        return "partial-in-map";
    }
    else {
        return "all-in-map-modified";
    }
}
function getAvailableStrategies(suggestion, openingInput, inclusionStatus) {
    const totalImagesIfMerged = openingInput.images.length + suggestion.input.images.length;
    const numImagesInProject = openingInput.images.length;
    const numImagesInSuggestion = suggestion.input.images.length;
    return {
        add: numImagesInProject === 0,
        overwrite: numImagesInProject > 0 && inclusionStatus !== "all-in-map-exact",
        merge: numImagesInProject > 0 &&
            numImagesInSuggestion > 0 &&
            totalImagesIfMerged <= editableOpeningReducer_1.MAX_IMAGES_PER_OPENING &&
            inclusionStatus !== "all-in-map-exact" &&
            inclusionStatus !== "all-in-map-modified",
    };
}
function getImageSameness(a, b) {
    if (a.id !== b.id) {
        return ImageSameness.NONE;
    }
    else if (a.flipX !== b.flipX ||
        a.flipY !== b.flipY ||
        a.height !== b.height ||
        a.width !== b.width ||
        a.rotation !== b.rotation ||
        a.x !== b.x ||
        a.y !== b.y) {
        return ImageSameness.MODIFIED;
    }
    else {
        return ImageSameness.FULL;
    }
}
// This assumes every image in the provided group has a unique ID. True for now...
function getMaxSameness(test, group) {
    for (let groupImage of group) {
        const sameness = getImageSameness(test, groupImage);
        if (sameness !== ImageSameness.NONE) {
            return sameness;
        }
    }
    return ImageSameness.NONE;
}
function getSamenessRange(samenesses) {
    return [Math.min(...samenesses), Math.max(...samenesses)];
}
//# sourceMappingURL=data:application/json;base64,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